import React, { useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Страницы, которые исторически используют суффикс языка: /login/en, /contacts/en …
const SUFFIX_ROUTES = ['/login', '/register', '/contacts', '/contact', '/privacy-policy', '/profile', '/klkt-segment'];

const segments = (pathname) => pathname.split('/').filter(Boolean);

export const langFromPath = (pathname) => (segments(pathname).includes('en') ? 'en' : 'ru');

const isLocalized = (base) => base === '/en' || base.startsWith('/en/') || base.endsWith('/en');

/** Добавляет к внутреннему адресу языковую часть. Для русского адрес не меняется. */
export function localize(path, lang) {
  if (lang !== 'en' || typeof path !== 'string' || !path.startsWith('/')) return path;
  const m = path.match(/^([^?#]*)(.*)$/);
  const base = m[1] || '/';
  const rest = m[2] || '';
  if (isLocalized(base) || base.startsWith('/admin') || base.startsWith('/pt/')) return path;
  if (base === '/') return `/en${rest}`;
  if (base === '/metrica' || base.startsWith('/metrica/')) return `/en${base}${rest}`;
  if (SUFFIX_ROUTES.some((r) => base === r || base.startsWith(`${r}/`))) return `${base.replace(/\/$/, '')}/en${rest}`;
  return `/en${base}${rest}`;
}

/** Тот же адрес на другом языке (для переключателя). */
export function switchLangPath(pathname, search = '', hash = '') {
  const segs = segments(pathname);
  const toEn = !segs.includes('en');
  let out;
  if (toEn) {
    out = localize(pathname || '/', 'en');
  } else {
    const rest = segs.filter((s, i) => !(s === 'en' && (i === 0 || i === segs.length - 1)));
    out = `/${rest.join('/')}`;
  }
  return `${out}${search}${hash}`;
}

/** Текущий язык по адресу и функция для построения ссылок. */
export function useLang() {
  const { pathname } = useLocation();
  const lang = langFromPath(pathname);
  return { lang, to: (path) => localize(path, lang) };
}

/** Один раз на приложение: синхронизирует язык i18next с адресом страницы. */
export function LangSync() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    if (pathname.startsWith('/pt/')) return;
    const lang = langFromPath(pathname);
    if ((i18n.language || '').slice(0, 2) !== lang) i18n.changeLanguage(lang);
  }, [pathname, i18n]);
  return null;
}

export const LLink = React.forwardRef(({ to, ...rest }, ref) => {
  const { lang } = useLang();
  return <Link ref={ref} to={localize(to, lang)} {...rest} />;
});

export const LNavLink = ({ to, ...rest }) => {
  const { lang } = useLang();
  return <NavLink to={localize(to, lang)} {...rest} />;
};
